var _defs, _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 582.2 582.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4d09aa;}.cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 291.1,
    cy: 291.1,
    r: 291.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M198.76,172.46c-17.07,6.4-50.27,28.78-49.4,106,0,0,5.28,61,29.61,116.72l80.08-12.32v-2a249.49,249.49,0,0,1,8.33-63.46c1.53-5.82,2.78-12.14,3.77-18.35a152.06,152.06,0,0,0-9-81.23A142.48,142.48,0,0,0,248,192.12c-.59-.86-1.08-1.72-2-2.87-2.95-3.72-10.94-14.91-28.95-18.35A33.94,33.94,0,0,0,198.76,172.46Z",
    transform: "translate(-7.18 -6.54)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M262.37,401.7c28,91.61-28.33,90.84-28.33,90.84-57.37,6.86-54.74-77.66-54.74-77.66Z",
    transform: "translate(-7.18 -6.54)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M411.38,87.38c16.14,8.48,46.29,34.83,35.8,111.33,0,0-12.85,59.87-43.94,112.12l-77.91-22.2.24-1.95a249.81,249.81,0,0,0-.35-64c-.8-6-1.25-12.39-1.46-18.68a152.12,152.12,0,0,1,19.09-79.47,142.58,142.58,0,0,1,17.23-23.77c.69-.78,1.29-1.57,2.33-2.6,3.39-3.32,12.72-13.43,31-14.59A33.89,33.89,0,0,1,411.38,87.38Z",
    transform: "translate(-7.18 -6.54)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M319.68,306.9c-39.21,87.41,16.78,93.66,16.78,93.66,56.07,14,64-70.22,64-70.22Z",
    transform: "translate(-7.18 -6.54)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActions);
export default __webpack_public_path__ + "static/media/actions.c25d48fe6706b4eae1fa52fb0011a662.svg";
export { ForwardRef as ReactComponent };